import { render, staticRenderFns } from "./c-content-chart-covid.vue?vue&type=template&id=3c5f55f7&"
import script from "./c-content-chart-covid.vue?vue&type=script&lang=js&"
export * from "./c-content-chart-covid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports